import { useSyncExternalStore } from "react";

// Only the header mounts the cart panel, and not for male partners or noHeader layouts.
let mountedPanels = 0;
const listeners = new Set<() => void>();

const notify = (): void => listeners.forEach((listener) => listener());

const subscribe = (listener: () => void): (() => void) => {
  listeners.add(listener);
  return () => listeners.delete(listener);
};

/** The panel's mount effect: counts it as mounted until the returned cleanup runs. */
export const registerCartPanel = (): (() => void) => {
  mountedPanels += 1;
  notify();
  return () => {
    mountedPanels -= 1;
    notify();
  };
};

export const useCartPanelMounted = (): boolean =>
  useSyncExternalStore(subscribe, () => mountedPanels > 0);
